/*eslint-disable */
define(function (require) {
  var $ = require('jquery');
  var _ = require('underscore');
  var config = require('common/page-config');
  var localeCode = config.locale.locale;

  require('jquery-validate');

  $.validator.addMethod('postalRef', validate);

  var regexp;

  if (_.contains(['de_DE', 'fr_FR', 'it_IT', 'es_ES'], localeCode)) {
    regexp = /^\d{5}$/;
  } else if (_.contains(['de_AT', 'de_CH'], localeCode)) {
    regexp = /^[1-9]\d{3}$/;
  } else if (localeCode === 'en_IE') {
    // Eircode
    //regexp = /^[AC-Y]{1}[0-9]{1}[0-9W]{1}[ \-]*[0-9AC-Y]{4}$/i;
  } else if (localeCode === 'en_GB') {
    regexp = /^((GIR {0,}0AA)|((([A-PR-UWYZ][A-HK-Y]?[0-9][0-9]?)|(([A-PR-UWYZ][0-9][A-HJKSTUW])|([A-PR-UWYZ][A-HK-Y][0-9][ABEHMNPRV-Y]))) {0,}[0-9][ABD-HJLNP-UW-Z]{2}))$/i;
  }

  function validate (value) {
    if (!regexp || !value) {
      return true
    }
    if (regexp) {
      return regexp.test($.trim(value));
    }
  }
});
